"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PointSelector = void 0;

var Point2D_1 = require("../../Core/Point2D");

var RegionData_1 = require("../../Core/RegionData");

var CrossElement_1 = require("../Component/CrossElement");

var Selector_1 = require("./Selector");
/**
 * The selector to define a point-region.
 */


var PointSelector = /*#__PURE__*/function (_Selector_1$Selector) {
  _inherits(PointSelector, _Selector_1$Selector);

  /**
   * Creates new `PointSelector` object.
   * @param parent - The parent SVG-element.
   * @param paper - The `Snap.Paper` element to draw on.
   * @param boundRect - The bounding box.
   * @param callbacks - The collection of callbacks.
   */
  function PointSelector(parent, paper, boundRect, callbacks) {
    var _this;

    _classCallCheck(this, PointSelector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PointSelector).call(this, parent, paper, boundRect, callbacks));

    _this.buildUIElements();

    _this.hide();

    return _this;
  }
  /**
   * Resizes the selector to specified `width` and `height`.
   * @param width - The new `width`.
   * @param height - The new `height`.
   */


  _createClass(PointSelector, [{
    key: "resize",
    value: function resize(width, height) {
      _get(_getPrototypeOf(PointSelector.prototype), "resize", this).call(this, width, height);

      this.crossA.resize(width, height);
    }
    /**
     * Hides the selector.
     */

  }, {
    key: "hide",
    value: function hide() {
      _get(_getPrototypeOf(PointSelector.prototype), "hide", this).call(this);

      this.hideAll([this.crossA, this.point]);
    }
    /**
     * Shows the selector.
     */

  }, {
    key: "show",
    value: function show() {
      _get(_getPrototypeOf(PointSelector.prototype), "show", this).call(this);

      this.showAll([this.crossA, this.point]);
    }
    /**
     * Builds selector's UI.
     */

  }, {
    key: "buildUIElements",
    value: function buildUIElements() {
      var _this2 = this;

      this.node = this.paper.g();
      this.node.addClass("pointSelector");
      this.crossA = new CrossElement_1.CrossElement(this.paper, this.boundRect);
      this.point = this.paper.circle(0, 0, PointSelector.DEFAULT_POINT_RADIUS);
      this.point.addClass("pointStyle");
      this.node.add(this.crossA.node);
      this.node.add(this.point);
      var listeners = [{
        event: "pointerenter",
        base: this.parentNode,
        listener: function listener() {
          return _this2.show();
        },
        bypass: false
      }, {
        event: "pointerleave",
        base: this.parentNode,
        listener: function listener() {
          return _this2.hide();
        },
        bypass: false
      }, {
        event: "pointerdown",
        base: this.parentNode,
        listener: function listener(e) {
          _this2.show();

          _this2.movePoint(_this2.point, _this2.crossA);

          if (typeof _this2.callbacks.onSelectionBegin === "function") {
            _this2.callbacks.onSelectionBegin();
          }
        },
        bypass: false
      }, {
        event: "pointerup",
        base: this.parentNode,
        listener: function listener(e) {
          if (typeof _this2.callbacks.onSelectionEnd === "function") {
            _this2.callbacks.onSelectionEnd(RegionData_1.RegionData.BuildPointRegionData(_this2.crossA.x, _this2.crossA.y));
          }
        },
        bypass: false
      }, {
        event: "pointermove",
        base: this.parentNode,
        listener: function listener(e) {
          var rect = _this2.parentNode.getClientRects();

          var p = new Point2D_1.Point2D(e.clientX - rect[0].left, e.clientY - rect[0].top);

          _this2.moveCross(_this2.crossA, p);

          _this2.movePoint(_this2.point, _this2.crossA);

          e.preventDefault();
        },
        bypass: false
      }];
      this.subscribeToEvents(listeners);
    }
  }]);

  return PointSelector;
}(Selector_1.Selector);

exports.PointSelector = PointSelector;
/**
 * Default radius for the point element. Can be redefined through css styles.
 */

PointSelector.DEFAULT_POINT_RADIUS = 6;